import { Injectable, inject } from "@angular/core";
import type { DashDraft } from "@magpie/types";
import { TrpcService } from "./trpc.service";

export interface AiDraftContext {
	name?: string;
	description?: string;
	itemCount?: number;
}

@Injectable({
	providedIn: "root",
})
export class AiService {
	private readonly trpc = inject(TrpcService);

	async generateDashDraft(
		brief: string,
		context?: AiDraftContext,
	): Promise<DashDraft> {
		if (!brief || brief.trim().length < 10) {
			throw new Error("Brief must be at least 10 characters");
		}

		return this.trpc.client.ai.draftDash.mutate({
			brief,
			context,
		}) as Promise<DashDraft>;
	}
}
